"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var pad_start_1 = __importDefault(require("core-js/library/fn/string/pad-start"));

var startOfDay_1 = __importDefault(require("date-fns/startOfDay"));

var addDays_1 = __importDefault(require("date-fns/addDays"));

var setHours_1 = __importDefault(require("date-fns/setHours"));

var format_1 = __importDefault(require("date-fns/format"));

var formatDistance_1 = __importDefault(require("date-fns/formatDistance"));

var differenceInMinutes_1 = __importDefault(require("date-fns/differenceInMinutes"));

var sv_1 = __importDefault(require("date-fns/locale/sv"));

var addSeconds_1 = __importDefault(require("date-fns/addSeconds"));

exports.addSeconds = addSeconds_1["default"];

var upperFirst = require("lodash/upperFirst");

exports.toReadableTime = function (timeInSeconds) {
  if (timeInSeconds === void 0) {
    timeInSeconds = 0;
  }

  if (timeInSeconds < 0) {
    return '--:--';
  }

  var hours = pad_start_1["default"](String(Math.floor(timeInSeconds / 3600)), 2, '0');
  var minutes = pad_start_1["default"](String(Math.floor(timeInSeconds % 3600 / 60)), 2, '0');
  var seconds = pad_start_1["default"](String(Math.floor(timeInSeconds % 60)), 2, '0');
  return "" + (hours !== '00' ? hours + ':' : '') + minutes + ":" + seconds;
};

exports.formatToHoursAndMinutes = function (timeInSeconds) {
  if (timeInSeconds < 0) {
    return '0 min';
  }

  var times = [Math.floor(timeInSeconds / 3600), Math.floor(timeInSeconds % 3600 / 60), Math.floor(timeInSeconds % 60)];
  var names = ['tim', 'min', 'sek'];

  if (times[0] > 0 || times[1] > 0) {
    var seconds = times[2];

    if (seconds >= 30) {
      times[1] += 1;
    }

    times[2] = 0;
  }

  return times.map(function (time, index) {
    if (time > 0) {
      return time + ' ' + names[index];
    }

    return '';
  }).filter(function (time) {
    return time.length > 0;
  }).join(' ');
};

exports.formatStartTime = function (date, now) {
  var startOfToday = setHours_1["default"](startOfDay_1["default"](now), 6);
  var startOfTomorrow = setHours_1["default"](startOfDay_1["default"](addDays_1["default"](now, 1)), 6);
  var dayAfterTomorrow = setHours_1["default"](startOfDay_1["default"](addDays_1["default"](now, 2)), 6);
  var startOfTonight = setHours_1["default"](startOfDay_1["default"](now), 18);

  if (date >= dayAfterTomorrow) {
    // fredag 5 januari 18.00
    return upperFirst(format_1["default"](date, 'EEEE d MMMM HH.mm', {
      locale: sv_1["default"]
    }));
  } else if (date >= startOfTomorrow) {
    return "Imorgon " + format_1["default"](date, 'HH.mm');
  } else if (date >= startOfTonight) {
    return "Ikv\xE4ll " + format_1["default"](date, 'HH.mm');
  } else if (date >= startOfToday) {
    return "Idag " + format_1["default"](date, 'HH.mm');
  }

  return upperFirst(format_1["default"](date, 'EEEE d MMMM HH.mm', {
    locale: sv_1["default"]
  }));
};

exports.formatTimeLeft = function (date, now) {
  return formatDistance_1["default"](date, now, {
    locale: sv_1["default"],
    onlyNumeric: true
  });
};

exports.minutesLeft = function (date, now) {
  return differenceInMinutes_1["default"](date, now);
};